export enum VendorType {
    DEVELOPER = 1,
    AGENCY = 2
}
